import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccountQRMainContainer = styled.div<React.CSSProperties>`
  align-self: center;
  left: ${1080 * Screen.widthRatio}px;
  text-align: center;
`;

export default AccountQRMainContainer;
